import styled from 'styled-components/macro'

import { Text } from '@loadsmart/miranda-react'
import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { Icon } from 'core/ui/components/icon/Icon'

import { type BaseShipment } from '../domain/BaseShipment'
import { formatLastLocation } from '../presenters/baseShipmentPresenter'

const Wrapper = styled.div`
  display: flex;
  background-color: ${toCSSValue('color-accent-20')};
  padding: ${getToken('spacing-2')} ${getToken('spacing-4')};
  border-bottom-left-radius: ${getToken('spacing-1')};
  border-bottom-right-radius: ${getToken('spacing-1')};
  gap: ${getToken('spacing-2')};
`

const StyledText = styled(Text)`
  --m-text-display: block;
  width: 100%;
  padding-right: ${getToken('spacing-4')};
`

type LastLocationProps = {
  shipment: BaseShipment
}

export function LastLocation({ shipment }: LastLocationProps) {
  const { lastLocation } = shipment

  if (!lastLocation) return null

  return (
    <Wrapper>
      <Icon name="pin" color="accent" />
      <StyledText color="color-accent-60" variant="body-md" ellipsized>
        {formatLastLocation(lastLocation)}
      </StyledText>
    </Wrapper>
  )
}
